export function focusInputSelectControlAfterOpen({
  inputSelectRef,
  refs,
  value,
}) {
  if (value) {
    refs.reference.current?.focus()
  } else {
    inputSelectRef.current?.focus()
  }
}
